import { SR_API_ACTION_PARTNER_GET_BY_ID, SR_API_ACTION_RATE_TOUR } from 'api/actionTypes';

import getTourList from 'client/actions/Tour/getList';
import askWantsToApply from 'client/actions/Listing/askWantsToApply';

export default async function rateShowing(
  { state, apiClient },
  { tourId, rating, dirtyExplanation, wtaExplanation, tags, feedback, listing, skipReview },
) {
  const partner = await apiClient.postWithState({
    state: state,
    action: SR_API_ACTION_PARTNER_GET_BY_ID,
    payload: {
      partnerId: listing.partnerId,
    },
  });

  return apiClient.postWithState({
    state: state,
    action: SR_API_ACTION_RATE_TOUR,
    payload: {
      tourId,
      rating,
      dirtyExplanation,
      wtaExplanation,
      tags,
      feedback,
      listingId: listing.id,
      skipReview,
    },
    onSuccess: () => {
      const _listing = {
        ...listing,
        externalApplicationEnabled: !!partner?.experienceConfiguration?.externalApplicationEnabled,
        externalApplicationUrl: partner?.experienceConfiguration?.externalApplicationUrl,
      };

      if (rating > 3) {
        askWantsToApply({ state, apiClient }, _listing);
      }

      getTourList({ state, apiClient }, { reloadTours: true });
    },
  });
}
